var normalizeBreakpointsArray = function normalizeBreakpointsArray(arr, theme) {
  var lengthDiff = theme.viewportsArray.length - arr.length;

  if (lengthDiff > 0) {
    for (var i = 0; i < lengthDiff; i++) {
      arr.push(arr[arr.length - 1]);
    }
  }

  return arr.slice(0, theme.viewportsArray.length);
};

export default normalizeBreakpointsArray;